import React, { useState } from 'react';
import FilterContainer from 'Containers/FilterContainer';
import Search from 'Components/Search';
import Dropdown from 'Components/DropDown';
import BasicTable from 'Components/BasicTable';
import Grid from '@mui/material/Grid';
import useTranslation from 'Hooks/useTranslation';
import useFetch from './Hooks/useFetch';
import useComponent from './Hooks/useComponent';
import { MembersContainer, dropdownStyle, ContainerTable } from './style';

export default function Members({ course }) {
  const { t2 } = useTranslation('CourseDetails');
  const [isLoading, setIsLoading] = useState(true);
  const { users, departments, jobTitles, terminals, setDepartment, setJobTitle, setTerminal, setFullName } = useFetch(
    course?.id,
    setIsLoading
  );

  const { thereIsComponent } = useComponent({ users });

  return (
    <MembersContainer>
      <FilterContainer>
        <Grid item xs={4} style={{ paddingLeft: '0' }}>
          <Search placeholder={t2('SearchPlaceholder')} setData={setFullName} />
        </Grid>

        <Grid item xs={6} style={dropdownStyle}>
          <Dropdown title={t2('Terminal')} setData={setTerminal} options={terminals} />
          <Dropdown title={t2('JobTitle')} setData={setJobTitle} options={jobTitles} />
          <Dropdown title={t2('Department')} setData={setDepartment} options={departments} />
        </Grid>
      </FilterContainer>
      <ContainerTable>
        <BasicTable
          information={users}
          headers={[t2('EmployeeName'), t2('Department'), t2('JobTitle'), t2('Terminal'), t2('CourseProgress')]}
          limit={5}
          thereIsComponent={thereIsComponent}
          widthColumn="20%"
          isLoading={isLoading}
        />
      </ContainerTable>
    </MembersContainer>
  );
}
